module.exports = {
  // home: {
  //   path: `/casa`,
  //   component: `src/pages/index.tsx`
  // },
  // shop: {
  //   path: `/shop`,
  //   component:`src/pages/shop.tsx`
  // }
  tags: {
    path: `/tags`,
    component:`src/pages/tag.tsx`
  }
}